import { render, staticRenderFns } from "./signupList.vue?vue&type=template&id=aa56a050&scoped=true&"
import script from "./signupList.vue?vue&type=script&lang=js&"
export * from "./signupList.vue?vue&type=script&lang=js&"
import style0 from "./signupList.vue?vue&type=style&index=0&id=aa56a050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa56a050",
  null
  
)

export default component.exports